import Action from "./Action";
import Shape from "../Main/Shape.js";
import {Coordinate as olCoordinate} from "ol/coordinate";
import {Serialization} from "../Main/Serializer";

export default class ShapeCoordinateMutationAction implements Action {

    private mutationIndex: number;
    private oldSlice: olCoordinate[];
    private newSlice: olCoordinate[];

    constructor(
        readonly shape: Shape,
        oldCoordinates: olCoordinate[],
    ) {
        this.determineSlices(oldCoordinates, this.shape.getCoordinates());
    }

    public apply(initial: boolean) {
        const coordinates = this.shape.getCoordinates().slice();
        if (!initial) {
            coordinates.splice(this.mutationIndex, this.oldSlice.length, ...this.newSlice);
        }
        this.shape.applyCoordinatesChange(coordinates, this.mutationIndex, this.newSlice.length - this.oldSlice.length);
    }

    public revert() {
        const coordinates = this.shape.getCoordinates().slice();
        coordinates.splice(this.mutationIndex, this.newSlice.length, ...this.oldSlice);
        this.shape.applyCoordinatesChange(coordinates, this.mutationIndex, this.oldSlice.length - this.newSlice.length);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    private determineSlices(a: olCoordinate[], b: olCoordinate[]) {
        const [i, j] = ShapeCoordinateMutationAction.determineDiff(a, b);

        this.mutationIndex = i;
        this.oldSlice = a.slice(i, a.length - j);
        this.newSlice = b.slice(i, b.length - j);
    }

    public static determineDiff(a: olCoordinate[], b: olCoordinate[]): [number, number] {
        const lMin = Math.min(a.length, b.length);

        let i;
        for (i = 0; i < lMin; i++) {
            if (
                a[i][0] !== b[i][0]
                || a[i][1] !== b[i][1]
            ) {
                break;
            }
        }

        let j;
        for (j = 0; j < lMin; j++) {
            if (
                a[a.length - 1 - j][0] !== b[b.length - 1 - j][0]
                || a[a.length - 1 - j][1] !== b[b.length - 1 - j][1]
            ) {
                break;
            }
        }

        return [i, j];
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            mutationIndex: this.mutationIndex,
            oldSlice: this.oldSlice,
            newSlice: this.newSlice,
        };
    }
}
